'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import AuditTrailHeader from './components/AuditTrailHeader';
import AuditTrailTable from './components/AuditTrailTable';

export default function AuditTrailPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen bg-background">
        <AuditTrailHeader />
        <div className="flex-1 flex flex-col gap-4 p-5 overflow-hidden">
          <AuditTrailTable />
        </div>
      </div>
    </AppLayout>
  );
}
